const MobileDepositAmountHeader = ({
  totalAmount
}) => {
  const displayAmount = totalAmount?.replace(/,/g, '') || '0';
  return <div className='flex flex-col justify-center items-center mt-2 w-full' data-sentry-component="MobileDepositAmountHeader" data-sentry-source-file="MobileDepositAmountHeader.tsx">
      <div className='w-full mt-2'>
        <div className='m-auto text-5xl md:text-7xl text-genius-cream break-all w-full'>
          <div className='relative h-20 w-full'>
            <div className={`absolute top-[0px] w-full justify-center items-center transition-all`}>
              <div>
                <p className={`text-center mt-4 ${!totalAmount || totalAmount?.length === 0 ? 'text-[60px]' : Number(displayAmount) > 1000 ? 'text-[36px] mt-5' : ''}`}>
                  {Number(displayAmount).toLocaleString(undefined, {
                  maximumFractionDigits: 2
                })}
                  <span className='text-genius-cream/70'>USD</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default MobileDepositAmountHeader;